import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIonViewWillEnter, IonButton } from '@ionic/react';
import { useParams, useHistory } from 'react-router-dom';
import { PageLayout } from 'containers/layout';
import MenuItems from 'containers/order/MenuItemList';
import AuthActions, { AuthSelectors } from 'redux/AuthRedux';
import { AppSelectors } from 'redux/AppRedux';
import OrderActions from 'redux/OrderRedux';
import { PaySelectors } from 'redux/PayRedux';

function ViewMenuList() {
  const history = useHistory();
  const params = useParams();
  const dispatch = useDispatch();
  const token = useSelector(AuthSelectors.selectToken);
  const venueId = params.locationId;
  const venueDetail = useSelector(AppSelectors.selectVenueDetailById(venueId));
  const ticket = useSelector(PaySelectors.selectTicket);

  const handleViewCheck = () => {
    if (token) {
      if (ticket) {
        history.push(`/locations/${ticket.venueId}/tab`);
      } else {
        history.push(`/locations`);
      }
    } else {
      dispatch(AuthActions.setRedirectUrl(`/locations`));
      history.push(`/auth/login`);
    }
  };

  useIonViewWillEnter(() => {
    dispatch(OrderActions.loadMenuItems(venueId));
  });

  return (
    <PageLayout
      title={venueDetail && venueDetail.name}
      back={token ? '/locations' : undefined}
      footer={
        <IonButton
          color="tertiary"
          expand="block"
          fill="solid"
          onClick={handleViewCheck}
        >
          View Your Check
        </IonButton>
      }
      wrapContent={false}
    >
      <MenuItems venueId={venueId} prefix={`/locations/${venueId}/view-menu`} />
    </PageLayout>
  );
}

export default ViewMenuList;
